const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);
/** Нормалізує значення domain з master-акаунту до hostname та origin */
export function resolveAccountDomain(raw) {
    const value = String(raw || '').trim();
    if (!value)
        return { hostname: '', origin: '' };
    const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
    try {
        const url = new URL(withProtocol);
        const hostname = url.hostname;
        const isLocalhost = LOCAL_HOSTS.has(hostname);
        const protocol = url.protocol || (isLocalhost ? 'http:' : 'https:');
        const origin = `${protocol}//${url.host}`;
        return { hostname, origin };
    }
    catch {
        const hostname = value.replace(/^https?:\/\//i, '').split('/')[0].split(':')[0];
        if (!hostname)
            return { hostname: '', origin: '' };
        const isLocalhost = LOCAL_HOSTS.has(hostname);
        const portMatch = value.match(/:(\d+)/);
        const origin = portMatch
            ? `${isLocalhost ? 'http' : 'https'}://${hostname}:${portMatch[1]}`
            : `${isLocalhost ? 'http' : 'https'}://${hostname}`;
        return { hostname, origin };
    }
}
/** Будує URL webhook Telegram-бота для origin tenant-а */
export function buildTelegramWebhookUrl(origin) {
    const base = String(origin || '').trim().replace(/\/+$/, '');
    if (!base)
        return '';
    return `${base}/api/eadmin/1.0/telegram/webhook`;
}
